import { Controller } from 'stimulus';

function includesBlank(el) {
  return el.textContent.includes('__________');
}

function addHighlight(el) {
  el.innerHTML = el.innerHTML.replace(/__________/g, '<highlight>__________</highlight>');
}

export default class extends Controller {
  connect() {
    [...this.element.querySelectorAll('liquid')].filter(includesBlank).forEach(addHighlight);
  }
}
